import { Box, Stack, useTheme } from "@mui/material";
import { tokens } from "../../../theme";
import ServiceQuoteForm from "../../proposal/service-quote-form/ServiceQuoteForm";
import {
  HeroSection,
  ScrollArrows
} from "./index";
import NavBar from "./NavBar";

// Data constants
const navItems = ["Home", "Services", "About", "Testimonials", "Contact Us"];

export default function LandingPage() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box
      sx={{
        bgcolor: colors.primary[900],
        overflow: "hidden",
        minWidth: { xs: "auto", lg: "1280px" },
        minHeight: "100vh",
        overflowX: { xs: "hidden", lg: "visible" },
      }}
    >
      {/* Header */}
      <NavBar navItems={navItems} />

      {/* Hero Decorative Image */}
      {/* <HeroDecorativeImage decorative1={decorative1} /> */}

      {/* Hero Section */}
      <HeroSection
        title="Be present no matter where you are."
        subtitle="Get a tailored quote for your specific needs"
      />

      <Stack sx={{ mx:{xs:3, md:0}, mb: "80px" }}>
        <ServiceQuoteForm />
      </Stack>

      {/* Scroll Arrows */}
      <Box
        sx={{
          position: "absolute",
          bottom: 24,
          left: "50%",
          transform: "translateX(-50%)",
          display: { xs: "none", md: "block" },
        }}
      >
        <ScrollArrows />
      </Box>

      {/* Services and About Section Container */}
      <Box
        sx={{
          position: "relative",
        }}
      >
        {/* Services Section */}
        {/* <ServicesSection services={serviceCards} /> */}

        {/* Decorative Images */}
        {/* <ServicesDecorativeImages decorative2={decorative2} /> */}

        {/* About Section */}
        {/* <AboutSection /> */}

        {/* Testimonials Section */}
        {/* <TestimonialsSection testimonials={testimonials} /> */}
      </Box>

      {/* Contact Section */}
      {/* <ContactSection
        branches={contactBranches}
        socialMediaIcons={socialMediaIcons}
      /> */}
    </Box>
  );
}